import React  from 'react';
import './App.css';
import Home from './component/Home';
import About from './component/About';
import Client from './component/Client';
import { Routes,Route, Link } from "react-router-dom";
import Projects from './component/Projects';
import Services from './component/Services';
import { useDispatch,useSelector } from 'react-redux';
import Contact from './component/Contact';
import { addItem } from './reducers/ToggleAction';
import Fade from "react-reveal/Fade"
import { AiOutlineClose } from "react-icons/ai"
import Terms from './sections/popUp/Terms';
import Privacy  from "./sections/popUp/Privacy"
import Cookie from './sections/popUp/Cookie';
import CeoPage from './sections/CeoPage';

function App() {

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const abc = state.numOfItems%2
  const checkTerm = state.terms%2
  const checkPolicy = state.privacyPolicy%2
  const checkCookie = state.cookie%2


  return (
    <div className="App">
         
         <div style={checkTerm == 1 ?{display:"block"}:{display:"none"}}>
         <Terms />
         </div>
         <div style={checkPolicy == 1 ?{display:"block"}:{display:"none"}}>
         <Privacy />
         </div>

         <div style={checkCookie == 1 ?{display:"block"}:{display:"none"}}>
         <Cookie />
         </div>

      <Fade>
      <div 
      id='sidebar-div'
       style={abc == 1 ? {display:"flex"} : {display:"none"}} >
      <div id='sidebar-1'></div>
      <div id='sidebar-2'>
        <div className='cursor-pointer flex justify-end text-end px-8 my-8' onClick={()=>dispatch(addItem())}>
          <AiOutlineClose color='white' size={20}/>
        </div>
        <Link to={"/"}>
          <p onClick={()=>dispatch(addItem())}>Home</p>
          </Link>

        <Link to={"/about"}>
          <p onClick={()=>dispatch(addItem())}>About</p>
          </Link>
        <Link to={"/services"}>
          <p onClick={()=>dispatch(addItem())}>Service</p>
          </Link>
        <Link to={"/client"}>
          <p onClick={()=>dispatch(addItem())}>Client</p>
          </Link>
        <Link to={"/project"}>
          <p onClick={()=>dispatch(addItem())}>Projects</p>
          </Link>
        <Link to={"/contact"}>
          <p onClick={()=>dispatch(addItem())}>Contact</p>
          </Link>
          <Link to={"/massage"}>
          <p onClick={()=>dispatch(addItem())}>Ceo massage</p>
          </Link>
        <div id='nav-button' className='flex justify-center'>
          <p id='sidebar-btn'>Let's Talk</p>
        </div>
      </div>
      </div>
      </Fade>




     <div id='comp-container' style={abc == 1 ? {display:"none"} : {display:"block"}}>
       
   

     <Routes basename="/">
         <Route path="/" element={<Home />} />
         <Route path="/about" element={<About />}/> 
         <Route path="/client" element={<Client />}/>
         <Route path="/project" element={<Projects />} />
         <Route path='/services' element={<Services />}/>
         <Route path='/contact' element={<Contact />}/>
         <Route path='/massage' element={<CeoPage />}/>
      </Routes>
     </div>

    </div>
  );
}

export default App;

